import { render, staticRenderFns } from "./stockDetail.vue?vue&type=template&id=62f280e9&scoped=true"
import script from "./stockDetail.vue?vue&type=script&lang=js"
export * from "./stockDetail.vue?vue&type=script&lang=js"
import style0 from "./stockDetail.vue?vue&type=style&index=0&id=62f280e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f280e9",
  null
  
)

export default component.exports